<template>
    <li>
        <a v-bind:href="item.Url.replace('~/','/')" v-bind:title="item.FirstName" class="testimonial-entry-content">
            <div v-if="item.PreviewText != ''" class="testimonial-entry-details testimonial-entry-text">
                <span class="testimonial-caret"></span>
                <p v-if="item.PreviewText != '' && item.PreviewText > 150" v-html="item.PreviewText.substring(0,150)+'...'"></p>
                <p v-else v-html="item.PreviewText"></p>
            </div>
            <div v-else class="testimonial-entry-details testimonial-entry-text">
                <span class="testimonial-caret"></span>
                <p class="truncated-story" v-html="item.StoryContent.substring(0,150)+'...'"></p>
            </div>
            <div class="testimonial-entry-bottom">
                <div class="testimonial-entry-thumb">
                    <img v-if="item.StoryPhotoUrl != ''" v-bind:src="item.StoryPhotoUrl" alt="story photo">
                    <img v-else src="/Content/images/person-avatar.png" alt="user icon">
                </div>
                <div class="testimonial-entry-meta">
                    <span class="testimonial-entry-author" v-if="item.LastName && item.State">{{ item.FirstName }} {{ item.LastName[0]}}., {{item.State}}</span>
                    <span class="testimonial-entry-author" v-else-if="item.LastName && !item.State">{{ item.FirstName }} {{ item.LastName[0] }}.</span>
                    <span class="testimonial-entry-author" v-else>{{ item.FirstName }}</span>
                    <span class="testimonial-entry-date">Published {{ formatDateAbv(item.FirstPublished) }}</span>
                </div>
            </div>
        </a>
    </li>
</template>

<script>
	import DateFormatService from '../../services/date-format.service';

	export default {
		props: ['item'],
		components: {

		},
		mounted: function () {

		},
		methods: {
			formatDateAbv(date) {
				return DateFormatService.formatDateAbv(date);
			},
        },
    }
</script>